<script>
    import { navigateTo } from 'svelte-router-spa'
    import * as data from '../store.js'
    import { token } from '../store.js'
    let corpName = data['corp_name']

    let clearVars = ['decMade', 'soreThroat', 'bodyPains', 'headache', 'fever', 'covidContact', 'supsectContact', 'travelAbroad', 'travelCity', 'triage', 'triageDesc', 'time', 'temp']
    function nxt() {
        function clear(item, index) {
            data[item].set('')
        }
        clearVars.forEach(clear)
        if ($token !== '') {
            navigateTo('name')
        } else {
            navigateTo('thermo')
        }
    }
</script>

<main>
    <div class="body">
        <p>I hereby authorize {$corpName}, for the collection and processing of the data indicated herein for the purpose of effecting control of the COVID-19 infection. I understand that my personal information is protected by RA 10173, Data Privacy Act of 2012, and that I am required by RA 11469, Bayanihan Heal as One Act, to provide truthful information.</p>
        <a class="btn btn-primary" on:click={nxt}>I agree →</a>
    </div>
</main>